<div class="h-1 border-b border-gray-200" *ngIf="!showSelectedItems">
    <mat-progress-bar *ngIf="!loaded" mode="indeterminate"></mat-progress-bar>
</div>
<div class="flex items-center py-4 pl-2 border-b" *ngIf="showSelectedItems">
    <button class="mr-1" mat-icon-button (click)="hideSelectedItemsPanel()">
        <em class="ti ti-arrow-narrow-left icon-size-7 text-gray-500"></em>
    </button>
    <div class="ml-1 flex items-center">
        <span class="text-lg">{{'selected.projects.text' | translate}}</span>
        <badge class="ml-2" [options]="getBadgeOptions()">
        </badge>
    </div>
</div>
<ul role="list" class="divide-y divide-gray-200 overflow-y-auto zuper-scrollbar data-picker-list-content-height"
    *ngIf="projects.length">
    <li class="project-data-picker-list-ele" *ngFor="let project of projects">
        <div class="hover:bg-gray-50 group relative flex items-center py-3 px-5"
            [ngClass]="{'cursor-pointer': selectOption === 'readOnly'}"
            (click)="selectOption === 'readOnly' ? viewProjectDetails($event, project.project_uid) : null">
            <a class="-m-1 block flex-1 p-1">
                <div class="relative flex min-w-0 flex-1 items-center">
                    <mat-checkbox (change)="selectProject($event, project)" *ngIf="selectOption === 'multiSelect'"
                        [checked]="isSelectedProject(project)" color="primary" disableRipple="true"
                        matTooltipPosition="below">
                        <div class="ml-4 truncate">
                            <ng-container *ngTemplateOutlet="projectsContent"></ng-container>
                        </div>
                    </mat-checkbox>
                    <mat-radio-button (change)="selectProject($event, project)" *ngIf="selectOption === 'select'"
                        [checked]="isSelectedProject(project)" color="primary" disableRipple="true"
                        matTooltipPosition="below">
                        <div class="ml-4 truncate">
                            <ng-container *ngTemplateOutlet="projectsContent"></ng-container>
                        </div>
                    </mat-radio-button>
                    <ng-container *ngIf="selectOption === 'readOnly'">
                        <div class="truncate w-full">
                            <ng-container *ngTemplateOutlet="projectsContent"></ng-container>
                        </div>
                    </ng-container>
                    <ng-template #projectsContent>
                        <div class="flex items-center justify-between">
                            <div class="w-full">
                                <div class="flex flex-row space-x-2 w-11/12">
                                    <p class="truncate text-lg font-medium text-gray-900 cursor-pointer">
                                        {{project?.project_prefix ?? ''}} {{project.project_number ? (project.project_number + ' - '): ''}}{{project.project_name}}
                                    </p>
                                </div>
                                <div class="flex flex-row space-x-2 mt-1" *ngIf="project?.project_category?.category_name">
                                    <p class="truncate text-base text-gray-500" *ngIf="project?.project_category?.category_name">
                                        {{project?.project_category?.category_name}}
                                    </p>
                                </div>
                                <div *ngIf="project?.project_start_date && project?.project_end_date">
                                    <span class="primary-font text-base">{{ project?.project_start_date | datetime}} - {{ project?.project_end_date | datetime}}</span>
                                </div>
                                <div *ngIf="(!project?.project_start_date && !project?.project_end_date) && project?.project_due_date">
                                    <span class="primary-font text-base">{{'text.due_by' | translate}}&nbsp;{{project?.project_due_date | datetime}}</span>
                                </div>
                            </div>
                            <div class="ml-auto mr-4">
                                <badge *ngIf="project?.project_current_status && project?.project_current_status?.project_status_name"
                                    [options]="getProjectStatusOptions(project?.project_current_status)"></badge>
                            </div>
                        </div>
                    </ng-template>
                    <div class="flex ml-auto items-center h-full">
                        <button mat-icon-button class="cursor-pointer" matTooltip="{{ updateArrowTooltipText(project.project_uid) | translate }}"
                            matTooltipPosition="above" *ngIf="!showSpinLoading(project.project_uid)" [ngClass]="rotateArrowIcon(project.project_uid)"
                            (click)="viewProjectDetails($event, project.project_uid)">
                            <mat-icon role="img" class="mat-icon notranslate mat-icon-no-color" aria-hidden="true" data-mat-icon-type="svg"
                                data-mat-icon-name="x" data-mat-icon-namespace="heroicons_outline">
                                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-chevron-down" width="24"
                                    height="24" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" fill="none"
                                    stroke-linecap="round" stroke-linejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none">
                                    </path>
                                    <polyline points="6 9 12 15 18 9"></polyline>
                                </svg>
                            </mat-icon>
                        </button>
                        <div class="py-2.5 h-10 w-12" *ngIf="showSpinLoading(project.project_uid)">
                            <mat-spinner class="ml-auto data-picker-spinner md:mr-3" [diameter]="18" style="width: 18px;height: 18px">
                            </mat-spinner>
                        </div>
                    </div>
                </div>
            </a>
        </div>
        <div class="p-4 bg-gray-100"
            *ngIf="('project_details_' + project.project_uid === projectEleId) && projectDetails && !isSpinLoading">
            <div class="bg-card rounded relative">
                <a target="_blank" class="hidden" #projectViewFullDetails href="{{viewProjectFullDetails(project.project_uid)}}"></a>
                <span class="cursor-pointer absolute right-0 pt-1 pr-1 z-50" (click)="projectViewFullDetails.click($event)"
                    matTooltip="{{'text.view_details.new_tab' | translate}}" matTooltipPosition="left">
                    <button mat-icon-button>
                        <mat-icon class="text-xl">open_in_new</mat-icon>
                    </button>
                </span>
                <div class="text-base">
                    <div class="px-2 truncate grid grid-cols-2">
                        <div *ngIf="projectDetails.customer?.customer_first_name"
                            class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer project-details-fields dark:bg-hover">
                            <p class="font-medium leading-5 truncate text-gray-500">
                                {{'customer' | translate}}</p>
                            <p class="mt-1 text-gray-900 truncate"
                                *ngIf="projectDetails.customer?.is_deleted === true || !utilityService.hasModuleAccess('CUSTOMER')">
                                {{projectDetails.customer.customer_first_name}}
                                {{projectDetails.customer.customer_last_name ?? ''}}</p>
                            <p class="mt-1 truncate">
                                <a class="text-gray-900 hover:underline hover:text-primary cursor-pointer" target="_blank"
                                    [routerLink]="utilityService.getLink('CUSTOMER', projectDetails.customer.customer_uid)"
                                    *ngIf="!projectDetails.customer?.is_deleted && utilityService.hasModuleAccess('CUSTOMER')">
                                    {{projectDetails.customer.customer_first_name}}
                                    {{projectDetails.customer.customer_last_name ?? ''}}</a></p>
                        </div>
                        <div *ngIf="projectDetails.organization"
                            class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer project-details-fields dark:bg-hover">
                            <p class="font-medium leading-5 truncate text-gray-500">
                                {{'text.organization_name' | translate}}</p>
                            <p class="mt-1 text-gray-900 truncate"
                                *ngIf="projectDetails.organization?.is_deleted === true || !utilityService.hasModuleAccess('ORGANIZATION')">
                                {{projectDetails.organization?.organization_name}}</p>
                            <p class="mt-1 truncate">
                                <a class="text-gray-900 hover:underline hover:text-primary cursor-pointer" target="_blank"
                                    [routerLink]="utilityService.getLink('ORGANIZATION', projectDetails.organization.organization_uid)"
                                    *ngIf="!projectDetails.organization?.is_deleted && utilityService.hasModuleAccess('ORGANIZATION')">
                                    {{projectDetails.organization?.organization_name}}</a>
                            </p>
                        </div>
                        <div *ngIf="projectDetails.project_priority"
                            class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer project-details-fields dark:bg-hover">
                            <p class="font-medium leading-5 truncate text-gray-500 mb-1">
                                {{'text.project_priority' | translate}}</p>
                            <badge class="my-2" [options]="getTagBadgeOptions(projectDetails?.project_priority)"
                                [matTooltip]="projectDetails?.project_priority" [matTooltipPosition]="'below'"></badge>
                        </div>
                        <div *ngIf="projectDetails.project_due_date"
                            class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer project-details-fields dark:bg-hover">
                            <p class="font-medium leading-5 truncate text-gray-500">
                                {{'due.date.text' | translate}}</p>
                            <p class="mt-1 text-gray-900">
                                {{projectDetails.project_due_date | dateformat}}</p>
                        </div>
                        <div *ngIf="projectDetails.created_at"
                            class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer project-details-fields dark:bg-hover">
                            <p class="font-medium leading-5 truncate text-gray-500">
                                {{'created_on.text' | translate}}</p>
                            <p class="mt-1 text-gray-900">
                                {{projectDetails.created_at | datetime}}</p>
                        </div>
                        <div *ngIf="projectDetails.created_by?.first_name"
                            class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer project-details-fields dark:bg-hover">
                            <p class="font-medium leading-5 truncate text-gray-500">
                                {{'created.by.text' | translate}}</p>
                            <p class="mt-1 text-gray-900 truncate">
                                {{projectDetails.created_by?.first_name}} {{projectDetails.created_by?.last_name ?? ''}}</p>
                        </div>
                    </div>
                </div>
                <div class="px-2 py-2 border-t text-base"
                    *ngIf="projectDetails.project_service_address && (projectDetails.project_service_address.street || projectDetails.project_service_address.state)">
                    <p class="font-medium leading-5 truncate text-gray-500 mb-3 ml-3">
                        {{'text.service_address' | translate}} </p>
                    <div class="px-3">
                        <p *ngIf="projectDetails.project_service_address.street" class="text-base mb-2">
                            {{projectDetails.project_service_address.street}}</p>
                        <p *ngIf="projectDetails.project_service_address.landmark" class="text-base mb-2">
                            {{projectDetails.project_service_address.landmark}}</p>
                        <p *ngIf="projectDetails.project_service_address.city" class="text-base mb-2">
                            {{projectDetails.project_service_address.city}}</p>
                        <p *ngIf="projectDetails.project_service_address.state" class="text-base mb-2">
                            {{projectDetails.project_service_address.state}}
                            {{projectDetails.project_service_address.zip_code ? '- ' +
                            projectDetails.project_service_address.zip_code : '' }}</p>
                        <p *ngIf="projectDetails.project_service_address.country" class="text-base">
                            {{projectDetails.project_service_address.country}}</p>
                    </div>
                </div>
                <div class="px-2 py-2 border-t text-base"
                    *ngIf="projectDetails.project_billing_address && (projectDetails.project_billing_address.street || projectDetails.project_billing_address.state)">
                    <p class="font-medium leading-5 truncate text-gray-500 mb-3 ml-3">
                        {{'billing.address.text' | translate}} </p>
                    <div class="px-3">
                        <p *ngIf="projectDetails.project_billing_address.street" class="text-base mb-2">
                            {{projectDetails.project_billing_address.street}}</p>
                        <p *ngIf="projectDetails.project_billing_address.landmark" class="text-base mb-2">
                            {{projectDetails.project_billing_address.landmark}}</p>
                        <p *ngIf="projectDetails.project_billing_address.city" class="text-base mb-2">
                            {{projectDetails.project_billing_address.city}}</p>
                        <p *ngIf="projectDetails.project_billing_address.state" class="text-base mb-2">
                            {{projectDetails.project_billing_address.state}}
                            {{projectDetails.project_billing_address.zip_code ? '- ' +
                            projectDetails.project_billing_address.zip_code : '' }}</p>
                        <p *ngIf="projectDetails.project_billing_address.country" class="text-base">
                            {{projectDetails.project_billing_address.country}}</p>
                    </div>
                </div>
            </div>
        </div>
    </li>
</ul>
<div class="overflow-hidden data-picker-list-content-height flex flex-col items-center justify-center"
    *ngIf="!projects.length && loaded && !showSelectedItems">
    <div class="flex flex-col items-center justify-center">
        <img class="w-40 m-auto" src="assets/images/svgs/no_parts_found.svg" alt="No Projects Found">
        <h4 class="font-medium mt-4 text-secondary text-base" *ngIf="onSearch">{{'projects.not_found.keyword' |
            translate}} '{{searchKey}}'</h4>
        <h4 class="font-medium mt-4 text-secondary text-base" *ngIf="!onSearch">{{'projects.not_found' |
            translate}}
        </h4>
    </div>
</div>